import { Components } from "@thisgorilla/primate-ds";
import styled, { useTheme } from "styled-components";

import {
  FlexColumn,
  FlexRow,
  FlexRowSpaced,
} from "../../../../../Common/Styles";
import { PeopleYouMayKnowProps } from "../PeopleYouMayKnow";
import { AvatarGroupAndDescription } from "./AvatarGroupAndDescription";

export const TitleAndButton = ({
  isOpen,
  setIsOpen,
  headerRef,
}: PeopleYouMayKnowProps.TitleAndButtonProps) => {
  const { typography, Color } = useTheme();

  return (
    <FlexColumn $gapInPx={10} ref={headerRef}>
      <FlexRowSpaced>
        <Components.Text
          text={"People you may know"}
          style={{ tokenStyle: typography.Heading.S }}
          fontWeight="font-weight-semibold"
          lineHeight="line-height-400"
          color={Color.text["text-emphasize-brand-bolder"].value}
        />
        <Components.IconButton
          iconType={isOpen ? "ChevronUp" : "ChevronDown"}
          size="XS"
          kind="Secondary"
          disabled={false}
          onClick={() => setIsOpen(!isOpen)}
        />
      </FlexRowSpaced>
      <FlexColumn $gapInPx={8}>
        <Heading>
          <FlexRow>
            <Components.Icon
              type="HelpCircle"
              size="16px"
              color={Color.icon["icon-secondary"].value}
            />
            <Components.Text
              style={{ tokenStyle: typography.Body.S }}
              text={"Discover people you may know through mutual followers."}
              color={Color.text["text-secondary"].value}
              lineHeight="line-height-50"
            />
          </FlexRow>
          <AvatarGroupAndDescription />
        </Heading>
      </FlexColumn>
    </FlexColumn>
  );
};

const Heading = styled(FlexColumn)`
  padding: ${({ theme }) => theme.spacing["spacing-1"].value}rem;
  padding-right: ${({ theme }) => theme.spacing["spacing-3"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-tertiary"].value};
`;
